import Review from './models/review';
import Schema from './models/schema';

export default {
  Schema,
  Review,
};
